module.exports = __webpack_public_path__ + "media/images/emblems/Echichens_2011-coat_of_arms-cfe1c9ce0163691675c18d49af00d8a2.svg";